module.exports = __webpack_public_path__ + "img/1.d0fa3c8c.png";